'use strict';

export const anonymousDonorElements = () => ({
    hideOnAnonymous: document.querySelectorAll('.hide-on-anonymous'),
    hiddenInputFields: container => (container.querySelectorAll('input[required],select[required]')),
    isAnonymousCheckbox: document.querySelector('input[type=checkbox][name=isAnonymous]')
});
